import axios, { AxiosResponse, CancelToken } from 'axios';

import { BASE_URL } from '../constants/config';
import { storageService } from './storage/storage';

export type TPostOptions = {
  timeout?: number;
  cancelToken?: CancelToken;
};

export const POST = async <T, B = undefined>(
  endPoint: string,
  data?: B,
  timeoutOrOptions?: number | TPostOptions
): Promise<AxiosResponse<T>> => {
  const options =
    typeof timeoutOrOptions === 'number'
      ? { timeout: timeoutOrOptions }
      : timeoutOrOptions || {};

  return getInstance(options.timeout).post(`${BASE_URL}${endPoint}`, data, {
    cancelToken: options.cancelToken,
  });
};

export const UPDATE = async <T, B = undefined>(
  endPoint: string,
  data?: B
): Promise<AxiosResponse<T>> =>
  getInstance().put(`${BASE_URL}${endPoint}`, data);

export const GET = async <T>(endpoint: string): Promise<AxiosResponse<T>> =>
  getInstance().get(`${BASE_URL}${endpoint}`);

const getInstance = (responseTimeout?: number) => {
  const instance = axios.create({
    baseURL: BASE_URL,
    timeout: responseTimeout || 60000,
  });
  instance.interceptors.request.use((config) => {
    const token = storageService.getToken();

    if (!token) {
      return config;
    }
    config = {
      ...config,
      headers: { Authorization: `Bearer ${token}` },
    };
    return config;
  });
  instance.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      if (
        error?.response?.status === 401 ||
        error?.response?.message === 'Token expired'
      ) {
        storageService.clearStorage();
        storageService.clearSessionStorage();
      }

      return Promise.reject(error);
    }
  );

  return instance;
};
